import { EvtHeader } from "components/header";
import React from "react";
import { useParams } from "react-router-dom";
import ContractForm from "../form";

const UpdateContract = () => {
  const { contractId } = useParams();

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Contract" />
      <div className="p-6 max-w-2xl">
        <ContractForm contractId={contractId} />
      </div>
    </div>
  );
};

export default UpdateContract;
